import React, { useEffect, useState } from 'react';
import { formatTimeDifference, formatString, formatRateRange, firestoreTimestampToDate } from '../util';
import { updateUserBookmarks, getUserBookmarks } from '../../../../../../data/user';
import { viewJobMetric } from '../../../../../../callable-cloud-functions/cloudFunctions';
import { useAuth } from '../../../../../../providers/auth';
import DialogWrapper from '../../../../../custom-ui/dialog/Dialog';
import useModal from '../../../../../../hooks/useModal';
import { getDeviceType } from '../util';
import JobsDetails from './JobsDetails';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import PayRateDesc from '../../../../../JobDetailsCom/PayRateDesc';
import AppliedTag from '../../../../../JobDetailsCom/AppliedTag';
import EmojiFlagText from '../../../../../custom-ui/emoji/EmojiFlagText';


const JobsCards = (
    { jobsData,
        setJobsDetailData = () => { },
        setBookmarks = () => { },
        bookmarks = [],
        setSelectedJobId = () => { },
        selectedJobId = () => { },
        userData = {},
        selectedId = "",
        jobsDetailData = "",
        aspectsOfJobMappedWithCode = "",
        aboutThisJobMappedWithCode = "",
        mustHavesMappedWithCode = "",
        isApplied = false,
        appliedAt = null
    }
) => {

    const {
        companyLogo,
        companyFullName,
        jobName,
        openings,
        workType,
        workTerm,
        workSettings,
        isSeasonal,
        isOconus,
        makeLiveDate,
        payRate,
        solutionType
    } = jobsData || {}


    const timeDifference = formatTimeDifference(makeLiveDate);
    const appliedDate = appliedAt
        ? (() => {
            const date = firestoreTimestampToDate(appliedAt);
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            const year = date.getFullYear();
            return `${month}/${day}/${year}`;
        })()
        : null;
    const auth = useAuth()
    const { isShowing: showDetailModal, toggle: toggleModalDetail } = useModal();
    const platform = getDeviceType()
    const handleJobsDetail = () => {
        setJobsDetailData(jobsData);
    }
    useEffect(() => {
        setSelectedJobId(selectedId)
    }, [selectedId])
    const handleClick = () => {
        viewJobMetric({
            jobId: jobsData.id,
            userId: auth?.user?.id,
            name: auth?.user?.name || "",
            email: auth?.user?.email || "",
            phone: auth?.user?.phone || "",
            platform: platform,
            solutionType: solutionType === "job_board" ? "DH" : "BPO",
        });
        // job name , user email need to pass as parameter
        setJobsDetailData(jobsData);
        if (getDeviceType() === 'IOS_Web' || getDeviceType() === 'Android_Web') {
            toggleModalDetail()
        }
        setSelectedJobId(jobsData.id);
    };

    const isSelected = selectedJobId === jobsData.id;
    const pillCount = 2 + (isSeasonal ? 1 : 0) + (isOconus ? 1 : 0);
    const isCompactPills = pillCount >= 4;

    const handleBookMark = async () => {
        await updateUserBookmarks(userData.user.id, jobsData?.id);
        setBookmarks((prevBookmarks) => {
            if (Array.isArray(prevBookmarks) && prevBookmarks.some((bookmark) => bookmark.jobId === jobsData?.id)) {
                return prevBookmarks.filter((bookmark) => bookmark.jobId !== jobsData?.id);
            } else {
                return [...prevBookmarks, { jobId: jobsData?.id, createdAt: new Date() }];
            }
        });
    }

    useEffect(() => {
        const fetchBookmarks = async () => {
            const updatedBookmarks = await getUserBookmarks(userData.user.id);
            setBookmarks(updatedBookmarks);
        };

        fetchBookmarks();
    }, [userData.user.id]);

    return (
        <>
            <div onClick={handleClick} className={`relative  mx-auto  mb-3  bg-white rounded-2xl p-4 flex flex-col md:flex-row md:items-end ${isSelected ? "border-2 border-instant-teams-blue-Main " : ""} `}>
                {openings > 1 && (
                    <span className="absolute top-0 right-0 bg-instant-teams-teal-D2 text-xs text-gray-600 px-2 py-1 rounded-tr-2xl ">
                        Multiple Openings
                    </span>
                )}
                <div className="flex xs:mt-4 md:mt-4 w-full md:w-auto md:flex-1 md:min-w-0 md:pr-3">
                    <div className="flex-shrink-0">
                        <img
                            src={solutionType == "bpo" ? "/images/InstantTeamsIcon-05.png" : companyLogo || "/images/company-placeholder.png"}
                            alt="Company Logo"
                            className="w-16 h-16 rounded object-contain"
                        />
                    </div>
                    <div className="ml-2 flex-grow min-w-0">
                        <div className="flex justify-between items-center">
                            <div className='cursor-pointer' onClick={handleJobsDetail}>
                                <p className="text-sm text-gray-500">{solutionType == "bpo" ? "Instant Teams" : companyFullName}</p>
                                <h2 className="text-lg font-semibold text-instant-teams-blue-Main">
                                    <EmojiFlagText>{jobName}</EmojiFlagText>
                                </h2>

                                <PayRateDesc payRate={payRate} />

                                {isApplied && (
                                    <div className="flex mt-[-10px] ml-[-10px]  ">
                                        <AppliedTag appliedDate={appliedDate} />
                                      
                                    </div>

                                )}
                            </div>
                            <div className="flex-shrink-0 mt-5 bg-gray-100 flex items-center justify-center w-8 h-8 rounded-full ml-4">
                                <button onClick={handleBookMark} className="text-gray-500 pl-2 pt-2 hover:text-gray-600">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 42 42"
                                        stroke="currentColor"
                                        className="w-6 h-6"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            fill={Array.isArray(bookmarks) && bookmarks.some(bookmark => bookmark.jobId === jobsData.id) ? "#19405E" : ""}
                                            d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3-7 3V5z"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-full md:w-auto md:flex-1 md:min-w-0 md:mt-4">
                    <div
                        className={`mt-3 flex w-full flex-nowrap items-center ${
                            isCompactPills ? "gap-2" : "gap-3 justify-start"
                        }`}
                    >
                        <span
                            className={`bg-gray-100 text-gray-800 text-sm py-1 rounded-full whitespace-nowrap text-center ${
                                isCompactPills
                                    ? "min-w-0 flex-1 px-2"
                                    : "xs:px-3 md:px-3 px-8"
                            }`}
                        >
                            {formatString(workSettings)}
                        </span>
                        <span
                            className={`bg-gray-100 text-gray-800 text-sm py-1 rounded-full whitespace-nowrap text-center ${
                                isCompactPills
                                    ? "min-w-0 flex-1 px-2"
                                    : "xs:px-3 md:px-3 px-8"
                            }`}
                        >
                            {formatString(workType)}
                        </span>
                        {isSeasonal && (
                            <span
                                className={`text-gray-800 text-sm py-1 rounded-full whitespace-nowrap text-center ${
                                    isCompactPills
                                        ? "min-w-0 flex-1 px-2"
                                        : "xs:px-3 md:px-3 px-8"
                                }`}
                                style={{ backgroundColor: "#C5FFBC" }}
                            >
                                Seasonal
                            </span>
                        )}
                        {isOconus && (
                            <span
                                className={`text-gray-800 text-sm py-1 rounded-full whitespace-nowrap text-center ${
                                    isCompactPills
                                        ? "min-w-0 flex-1 px-2"
                                        : "xs:px-3 md:px-3 px-8"
                                }`}
                                style={{ backgroundColor: "#d9e1fd" }}
                            >
                                OCONUS
                            </span>
                        )}
                    </div>
                </div>
            </div>

            {showDetailModal &&
                (
                    <DialogWrapper
                        title=""
                        onClose={() => { }}
                    >
                        <div className='w-full mt-3 mr-4  flex justify-end items-center '>
                            <div
                                className="flex  justify-center items-center w-7 h-7 bg-gray-200 rounded-full cursor-pointer"
                                onClick={toggleModalDetail}
                            >
                                <FontAwesomeIcon icon={faTimes} color="#565656" />
                            </div>
                        </div>
                        <div className='w-auto h-auto overflow-y-auto no-scrollbar'>
                            <JobsDetails bookmarks={bookmarks} setBookmarks={setBookmarks} jobsDetailData={jobsData}
                                aspectsOfJobMappedWithCode={aspectsOfJobMappedWithCode}
                                aboutThisJobMappedWithCode={aboutThisJobMappedWithCode}
                                mustHavesMappedWithCode={mustHavesMappedWithCode}
                            />
                        </div>
                    </DialogWrapper>
                )
            }
        </>
    );
};

export default JobsCards;
